import type { ToolbarProps } from './toolbar.types.ts';
import styles from './toolbar.module.scss';

export function Toolbar({ children }: ToolbarProps) {
  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>{children}</div>
    </div>
  );
}
